import React from "react";
import { Helmet } from "react-helmet";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import CookieBanner from "../CookieBanner/CookieBanner";
import favicon from "../../../assets/image/favicon.ico";
import SkipNav from "../SkipNav/Skipnav";

import ensighten from "../../utils/ensighten";

// This is a coverall style
import "@coopdigital/foundations/dist/vars/vars.css";
import "@coopdigital/foundations/dist/foundations.css";

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <link rel="icon" href={favicon} type="image/x-icon" />
      </Helmet>
      <SkipNav />
      <CookieBanner />

      {ensighten ? (
        <script type="text/javascript" src={ensighten}></script>
      ) : null}
      <Header />

      <main id="main">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
